export default __webpack_public_path__ + "35ecd1d90e5d42dfba10e021b4fc67d9.png";